const GENERIC_TYPES = [
  "BATERIA",
  "CARREGADOR",
  "ESTRADO",
  "CARRINHO",
  "CARRINHO PARA TROCA DE BATERIA",
  "PALETEIRA",
  "CILINDRO DE GAS",
  "COMPONENTES ELETRONICOS",
  "PEÇA"
];

export const isGenericEquipment = (equipment) => {
  if (!equipment) return false;

  if (equipment.is_generic === true || equipment.is_generic === 1) {
    return true;
  }

  const type = (equipment.type || "").trim().toUpperCase();
  return GENERIC_TYPES.includes(type);
};

export const formatEquipmentOption = (equip) => ({
  value: equip.id,
  label: `${equip?.equipment || ""} | ${equip?.brand?.name || ""} | ${
    equip?.model?.name || ""
  }`,
  is_generic: isGenericEquipment(equip)
});

export const sameEquipmentId = (firstId, secondId) =>
  Number(firstId) === Number(secondId);
